import { render, staticRenderFns } from "./LdpSummaryDialog.vue?vue&type=template&id=0539e434&scoped=true"
import script from "./LdpSummaryDialog.vue?vue&type=script&lang=js"
export * from "./LdpSummaryDialog.vue?vue&type=script&lang=js"
import style0 from "./LdpSummaryDialog.vue?vue&type=style&index=0&id=0539e434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539e434",
  null
  
)

export default component.exports